import { NESTED_ROUTES } from 'common/src/routes/BaseRoutes';

import Dashboard from 'portal/src/components/common/Dashboard';
import { DASHBOARD_SLUGS } from 'portal/src/constants/luzmoDashboards';

import { RouteDefinition } from './routeGenerator';

export const costRouteDefinitions: RouteDefinition[] = [
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.ALL_UTILITIES} />,
    name: 'All Utilities',
    path: NESTED_ROUTES.COST.ALL_UTILITIES,
    description: 'Analyze cost trends across all utilities',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.YEAR_OVER_YEAR} />,
    name: 'Year-over-Year',
    path: NESTED_ROUTES.COST.YEAR_OVER_YEAR,
    description: 'Analyze year-over-year costs',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.YEAR_OVER_YEAR_BAR} />
    ),
    name: 'Year-over-Year Bar',
    path: NESTED_ROUTES.COST.YEAR_OVER_YEAR_BAR,
    description: 'Analyze year-over-year costs',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.LINE_ITEM_COST} />,
    name: 'Line Items Cost',
    path: NESTED_ROUTES.COST.LINE_ITEM_COST,
    description: 'Analyze cost by line item type and description',
  },
  {
    element: (
      <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.WEATHER_NORMALIZED_COST} />
    ),
    name: 'Weather Normalized Cost',
    path: NESTED_ROUTES.COST.WEATHER_NORMALIZED_COST,
    description: 'Analyze costs in relation to changes in weather',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.BUDGETS_ACTUALS} />,
    name: 'Budget vs. Actuals',
    path: NESTED_ROUTES.COST.BUDGETS_ACTUALS,
    description: 'Analyze budget scenarios vs. actual costs',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.BUDGET_REVIEW} />,
    name: 'Budget Review',
    path: NESTED_ROUTES.COST.BUDGET_REVIEW,
    description: 'Review forecasted budget scenarios',
  },
  {
    element: <Dashboard dashboardSlug={DASHBOARD_SLUGS.COST.UNIT_ECONOMICS} />,
    name: 'Unit Economics',
    path: NESTED_ROUTES.COST.UNIT_ECONOMICS,
    description: 'Analyze utility unit economics and rate trends',
  },
];
